export default function DecimalsOnly(float) {
	float = float.toFixed(2);
	var radixPos = String(float).indexOf('.');

	var value = String(float).slice(radixPos);

	return value;
}
